/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';

import { Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Hoverable from 'app/developer-v3/components/Hoverable';
import Link from 'app/common/components/Link';

import Title from './Title';
import { checkMap } from '../constants';

type Props = {
  link: string | null;
  iconType: 'errors' | 'warnings';
  checkType: string;
  violationType: string;
};

const Styles = {
  root: css`
    padding: 15px 15px 10px;
  `,
  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  iconWrapper: isHovered => [
    css`
      vertical-align: middle;
      transition: transform 150ms ease-in-out;
      display: inline-flex;
    `,
    isHovered &&
      css`
        transform: translateX(3px);
      `,
  ],
  link: css`
    align-items: center;
    display: flex;
  `,
  linkWrapper: css`
    width: auto;
  `,
};

/**
 * Renders the header section for documentation
 * Shows a title for the sub-section where the error happened
 *
 * Links to the view with the error
 *
 * @param {*} props
 */
const Header = (props: Props) => (
  <header css={Styles.root}>
    <section css={Styles.header}>
      <Title
        check={props.checkType}
        icon={props.iconType}
        violationType={props.violationType}
      />
      {props.link && (
        <Hoverable>
          {({ isHovered }) => (
            <div css={Styles.linkWrapper}>
              <Link
                aria-label="Loads the form with the current error"
                css={Styles.link}
                href={props.link}
              >
                <Text color="UiPrimaryStrongest" fontWeight={600}>
                  Go to {checkMap[props.checkType]}
                </Text>
                <span
                  css={Styles.iconWrapper(isHovered)}
                  id="docs-header-link-arrow"
                >
                  <Icon
                    color="UiPrimaryStrongest"
                    name="arrowSmallRight"
                    size={16}
                  />
                </span>
              </Link>
            </div>
          )}
        </Hoverable>
      )}
    </section>
  </header>
);

export default Header;
